export enum FeatureFlag {
  ACCOUNT_HOOKS = 'account_hooks',
  ARCHIVE_PROJECT = 'archive_project',
  ASSET_MANAGEMENT = 'asset_management_accounting',
  AUTOMATIONS = 'automations',
  COMPLETED_AT_FOR_PREDECESSORS = 'completed_at_for_predecessors',
  DISPOSITIONS_TAB = 'dispositions_tab',
  EMAIL_ENGAGEMENTS = 'email_engagements',
  ETHAN = 'ethan',
  FACILITY_REPORTS = 'facility_reports',
  KEY_DATE_LINKING = 'key_date_linked_fields',
  LOAN_QUOTES = 'loan_quotes',
  NESTED_FILTERS = 'nested_filters',
  PIPELINE_MAP = 'pipeline_map',
  POSTAL_LEASE_ABSTRACT = 'postal_lease_abstract',
  REPORTS_TAB = 'reports_tab',
  SORT_VISUALIZATION_KEYS = 'sort_visualization_keys',
  SUMMARY_FORMULAS = 'summary_formulas',
  TABLE_REPORT_VISUALIZATION = 'table_report_visualization',
  TASKS_CUSTOM_FIELDS = 'tasks_custom_fields',
  TASKS_LIST_BASELINES = 'task_list_baselines',
  ZERO_HANDLING = 'zero_handling',
  INVERSE_RELATIONSHIP = 'inverse_relationship',
  MICROSOFT_PROJECT = 'microsoft_project',
  NEW_LEASES_TAB = 'new_leases_tab',
  DRAFT_TASK_LIST = 'draft_task_lists',
  NEW_NAVIGATION = 'new_navigation',
}
